import React from 'react';
import {Viewer} from "./components/Viewer";

function App() {
  return (
    <div className="App">
      <Viewer />
    </div>
  );
}

export default App;
